var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermometerNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 41,
    viewBox: "0 0 21 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.089 23.0463V7.16664C17.089 3.48477 14.1042 0.5 10.4224 0.5C6.74049 0.5 3.75572 3.48477 3.75572 7.16664V23.0463C1.70986 24.8773 0.422363 27.5384 0.422363 30.5C0.422363 36.0229 4.89955 40.5 10.4224 40.5C15.9452 40.5 20.4224 36.0229 20.4224 30.5C20.4224 27.5384 19.1349 24.8773 17.089 23.0463ZM10.4224 37.1666C6.74049 37.1666 3.75572 34.1819 3.75572 30.5C3.75572 28.5752 4.57143 26.7897 5.97877 25.5301L7.08908 24.5363V7.16664C7.08908 5.3257 8.5815 3.83328 10.4224 3.83328C12.2634 3.83328 13.7558 5.32562 13.7558 7.16664V24.5363L14.8661 25.5301C16.2735 26.7897 17.0892 28.5752 17.0892 30.5C17.089 34.1819 14.1042 37.1666 10.4224 37.1666Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75586 15.5009H12.0892V25.7846C14.0311 26.471 15.4224 28.323 15.4224 30.5C15.4224 33.2614 13.1838 35.5 10.4224 35.5C7.66094 35.5 5.42236 33.2614 5.42236 30.5C5.42236 28.3229 6.81379 26.4708 8.75586 25.7844V15.5009Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometerNormal);
export default __webpack_public_path__ + "static/media/thermometer_normal.1540305060d1652b9a7c44b1d447ee1a.svg";
export { ForwardRef as ReactComponent };